import React, { lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
import sanitizeHtml from "sanitize-html";
import "./TACModal.scss";
const Modal: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/Modal/Modal")
);

const TACModal: React.FC = (props: Record<string, any>) => {
  return (
    <div>
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <Modal
          modalOpen={props.data.showTacModal}
          closeModal={props.onCloseModal}
          contentLabel="TAC"
          className="auth-screen__tac-accept-modal"
          underlayClickExits={false}
          escapeExits={false}
        >
          <div className="tac-modal__title-container">
            {props.data.session && props.data.session.firstTimeUser === true ? (
              <h3 className="tac-modal__title-text">
                <FormattedMessage
                  tagName="span"
                  id="termsandconditions-accept-to-continue"
                />
              </h3>
            ) : (
              <h3 className="tac-modal__title-text">
                <FormattedMessage
                  tagName="span"
                  id="termsandconditions-accept-updated-to-continue"
                />
              </h3>
            )}
          </div>

          <div
            className="footer-container__modal"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(props.data.html),
            }}
          />
          <div className="auth-screen__form__submit">
            <button onClick={props.setTacAccepted}>
              <FormattedMessage tagName="span" id="termsandconditions-accept" />
            </button>
          </div>
        </Modal>
      </Suspense>
    </div>
  );
};

export default TACModal;
